export const NOTIFICATION_MODULES = [
  { label: 'Action Tracker', value: 'action-tracker' },
  { label: 'BPO', value: 'bpo' },
  { label: 'Coaching Tracker', value: 'coaching-tracker' },
  { label: 'Consultant Visit', value: 'consultant-visit' },
  { label: 'Incident Management', value: 'incident-management' },
  { label: 'Leadership Assessment', value: 'leadership-assessment' },
  { label: 'Risk Profiling', value: 'risk-profiling' },
  { label: 'Safety Observation', value: 'safety-observation' },
  { label: 'SPI', value: 'spi' },
  { label: 'SPS', value: 'sps' },
  { label: 'Target Scheduling', value: 'target-scheduling' },
  { label: 'Unsafe Conditions', value: 'unsafe-condition' },
  { label: 'Work Cycle Verification', value: 'work-cycle-verification' },
]

const NOTIFICATION_MODULE_LABELS = new Map(
  NOTIFICATION_MODULES.map(({ value, label }) => [value, label]),
)

export function getNotificationModuleLabel(value) {
  if (!value) {
    return null
  }

  return (
    NOTIFICATION_MODULE_LABELS.get(value)
    ?? value
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  )
}
